import { createSelector } from "reselect";
import { RootState } from "../store";

const permissionSelector = (state: RootState) => state?.persistReducers.login

export const selectFeaturePermissions = createSelector(permissionSelector, state => state.featurePermissions)